module.exports = "/assets/3ebf402ebcdb0670992eb1dae3ac886a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/2M.png
// module id = 988
// module chunks = 0